module.exports = __webpack_public_path__ + "img/ios-watch.1c1a661a.svg";